import { defineMessages } from 'react-intl';

export default defineMessages({
	navigationWarning: {
		defaultMessage: 'You have unsubmitted changes. Are you sure you want to leave?',
		description:
			'Messsage shown to users when they navigate away from a form that has been filled out.',
		id: 'cv.navigation.prompt.warning',
	},
});
